import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext.js';

const AboutPage = () => {
  const { isLight } = useTheme();
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText('contact@theardenresearch.com');
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="min-h-screen pt-24 sm:pt-32 pb-16 sm:pb-24">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-8 md:px-12">

        {/* Back Navigation */}
        <Link
          to="/"
          className={`inline-flex items-center gap-2 text-xs sm:text-sm font-mono uppercase tracking-widest transition-colors mb-8 sm:mb-12 ${
            isLight ? 'text-gray-400 hover:text-primary' : 'text-white/50 hover:text-accent'
          }`}
        >
          <span className="material-symbols-outlined text-sm">arrow_back</span>
          Back to Home
        </Link>

        {/* Page Header */}
        <div className="mb-12 sm:mb-16">
          <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
            <div className={`w-1.5 h-1.5 rounded-full ${
              isLight ? 'bg-primary shadow-[0_0_8px_#5e19e6]' : 'bg-accent shadow-[0_0_8px_#00f0ff]'
            }`} />
            <span className={`text-[9px] sm:text-[10px] font-mono uppercase tracking-widest ${
              isLight ? 'text-primary' : 'text-accent'
            }`}>
              About
            </span>
          </div>

          <h1 className={`text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light tracking-tight leading-[1.1] mb-6 ${
            isLight ? 'text-gray-900' : 'text-white'
          }`}>
            About <br />
            <span className={`font-bold text-transparent bg-clip-text bg-gradient-to-r ${
              isLight ? 'from-gray-900 via-gray-500 to-gray-300' : 'from-white via-white/70 to-white/20'
            }`}>
              Arden Research.
            </span>
          </h1>

          <p className={`text-base sm:text-lg md:text-xl font-light leading-relaxed max-w-[65ch] ${
            isLight ? 'text-gray-500' : 'text-white/60'
          }`}>
            Quantitative research and structured learning — built for modern thinkers.
          </p>
        </div>

        {/* Content Section */}
        <div className="space-y-12 sm:space-y-16">

          <section className="glass-panel p-6 sm:p-8 md:p-10 rounded-xl">
            <h2 className={`text-xl sm:text-2xl md:text-3xl font-light mb-4 ${
              isLight ? 'text-gray-900' : 'text-white'
            }`}>
              Get in Touch
            </h2>
            <p className={`leading-relaxed mb-6 ${isLight ? 'text-gray-500' : 'text-white/60'}`}>
              Interested in our quantitative research services? We'd love to hear from you. Reach out to discuss how Arden Research can support your goals.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="mailto:contact@theardenresearch.com"
                className={`inline-flex items-center gap-2 sm:gap-3 px-4 sm:px-6 py-2.5 sm:py-3 border rounded-lg text-xs sm:text-sm font-mono tracking-widest transition-all ${
                  isLight
                    ? 'bg-primary/10 border-primary/30 text-primary hover:bg-primary hover:text-white'
                    : 'bg-accent/10 border-accent/30 text-accent hover:bg-accent hover:text-black'
                }`}
              >
                contact@theardenresearch.com
              </a>
              <button
                onClick={copyEmail}
                className={`flex items-center justify-center w-10 h-10 border rounded-lg transition-all ${
                  isLight
                    ? 'bg-primary/10 border-primary/30 text-primary hover:bg-primary hover:text-white'
                    : 'bg-accent/10 border-accent/30 text-accent hover:bg-accent hover:text-black'
                }`}
                title="Copy email"
              >
                <span className="material-symbols-outlined text-sm">
                  {copied ? 'check' : 'content_copy'}
                </span>
              </button>
            </div>
          </section>

        </div>

      </div>
    </div>
  );
};

export default AboutPage;
